import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { useExercise } from './../../../context/exercise';

import { navRoutes as NR } from '../../../constants';
import Content from './Content';

const CoachNotes = () => {
  const { exerciseId } = useParams();
  const { exercise } = useExercise();
  const { key } = exercise;
  const { intro, steps } = exercise.coachNotes || {
    intro: '',
    steps: '',
  };
  const navigate = useNavigate();
  const { state } = useLocation();

  const previewExerciseLink = NR.EXERCISES.SINGLE_STEP_PREVIEW.replace(
    ':exerciseId',
    exerciseId
  ).replace(':stepId', exercise.steps && exercise.steps[0]?.id);

  const explainerPage = NR.EXERCISES.EXERCISE_EXPLAINER.replace(
    ':exerciseId',
    exerciseId
  );

  const onClose = async () => {
    if (state?.canGoBack) return navigate(-1);
    return navigate(explainerPage);
  };

  return (
    <Content
      exKey={key}
      intro={intro?.trim()}
      previewExerciseLink={previewExerciseLink}
      steps={steps?.trim()}
      onClose={onClose}
    />
  );
};

export { Content };
export default CoachNotes;
